import type { Components, Theme } from "@mui/material/styles";
import { MuiChip } from "./MuiChip";
import { MuiAccordion } from "./MuiAccordion";
import { MuiAlert } from "./MuiAlert";
import { MuiButton } from "./MuiButton";
import { MuiInputLabel } from "./MuiInputLabel";
import { MuiOutlinedInput } from "./MuiOutlinedInput";
import { MuiTab } from "./MuiTab";
import { MuiTypography } from "./MuiTypography";
import { MuiTooltip } from "./MuiTooltip";

export const components: Components<Theme> = {
  MuiAccordion,
  MuiChip,
  MuiTooltip,
  MuiAlert,
  MuiButton,
  MuiInputLabel,
  MuiOutlinedInput,
  MuiTab,
  MuiTypography,
};
